import { useEffect } from "react";
// import * as Yup from "yup";
import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import View from "../../components/GeneratePdf/View";
import { toast } from "react-toastify";
import { requestAuth } from "../../components/services/RequestService";
import Text from "../../components/GeneratePdf/Text";
import { useAuth } from "../../contexts/AuthContext";
// import { useDialog } from "../../contexts/DialogContext";
// import FormDefault from "../../components/Forms/FormDefault";
import { Page, Document, PDFViewer, Image, pdf } from "@react-pdf/renderer";
import * as dayjs from "dayjs";
// import { es } from "dayjs/locale/es";
import { TextParagraph, TextSubTitle } from "./RenderQuotation";
dayjs.locale("es");

const RenderLiquidaciónProforma = (props) => {
  const { accountNumber } = props;
  const { user } = useAuth()
  // const { openDialog, dialogClose } = useDialog();

  // const { data, loading } = Request({
  //   urlApi: "/dropdown/user/accountNumbers",
  // });

  // function handleProform(values) {
  //   openDialog(
  //     <LiquidaciónProform {...props} accountNumber={values.account} />
  //   );
  // }

  // function handleAccount() {
  //   const list = data.map((item) =>
  //     item.accountNumber
  //       ? {
  //         label: `${item.accountNumber} - ${item.name} ${item.fatherLastName}`,
  //         value: item.accountNumber,
  //       }
  //       : null
  //   );
  //   return list.filter((n) => n);
  // }

  // if (!loading) {
  //   return <Circle />;
  // }
  // return (
  //   <FormDefault
  //     tittle="Elaborador por/ Nro de Cuenta Bancaria a Depositar"
  //     fields={[
  //       {
  //         label: "Atención",
  //         name: "account",
  //         typeInput: "select",
  //         options: handleAccount(),
  //         //   [
  //         //   {
  //         //     label: "Original",
  //         //     value: "Original",
  //         //   },
  //         //   {
  //         //     label: "Copia",
  //         //     value: "Copia",
  //         //   },
  //         //   {
  //         //     label: "Fotocopia simple",
  //         //     value: "Fotocopia simple",
  //         //   },
  //         //   {
  //         //     label: "Fotocopia legalizada",
  //         //     value: "Fotocopia legalizada",
  //         //   },
  //         // ],
  //         // typeInput: "selectNewOption",
  //         // urlApi: "/dropdown/user/accountNumbers",
  //         // value: "name",
  //         // labelOption: "name",
  //       },
  //     ]}
  //     initialValues={{
  //       account: "",
  //     }}
  //     validationSchema={Yup.object().shape({
  //       // atn: Yup.string().required("Campo requerido"),
  //     })}
  //     onSubmit={handleProform}
  //     buttonName="Registrar"
  //   />
  // );
  return <LiquidationProform {...props} accountNumber={accountNumber ?? user?.user?.accountNumber} user={user} />
};

const LiquidationProform = (props) => {
  const { procedure, accountNumber, isQuotation, user } = props;
  const { data, loading } = Request({
    urlApi: `/tradecruz/${procedure.id || procedure.procedureId}/proform`,
  });

  useEffect(() => {
    if (loading && data) {
      handleOnClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if (!loading) {
    return <Circle />;
  }

  const MyDoc = (
    <Document>
      <Page size="A4" style={{ padding: "20px" }}>
        <View flexDirection="column" borderContent>
          <View padding="4px" style={{ backgroundColor: "#d38c19" }}></View>
          <View flexDirection="column">
            <View
              justifyContent="space-between"
              alignItems="center"
              padding="4px 0"
            >
              <View width="25%">
                <Image src="https://www.aciabolsrl.com/_next/image?url=%2Fimages%2FLogo%2Flogo.png&w=3840&q=75" style={{ height: "50px" }} />
              </View>
              <View
                width="60%"
                flexDirection="column"
                alignItems="flex-end"
                justifyContent="flex-end"
              >
                <Text
                  color="#004080"
                  padding="0px 3px"
                  textAlign="end"
                  fontSize="16px"
                  bold
                >
                  {isQuotation ? 'COTIZACIÓN' : 'PROFORMA DE DESPACHO'}
                </Text>
                <Text
                  color="#d38c19"
                  padding="0px 3px"
                  fontSize="18px"
                  bold
                  textAlign="end"
                >
                  {isQuotation ? data.nroQuotation : data.codigoDeInterno}
                </Text>
                <Text fontSize="10px" padding="0px 3px" textAlign="end">
                  La Paz {dayjs().format("DD")} de {dayjs().format("MMMM")}{" "}
                  del {dayjs().format("YYYY")}
                </Text>
              </View>
            </View>
            <View
              border={{ top: true }}
              // style={{ marginTop: "5px" }}
              padding="3px 0px 0px 0px"
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    SEÑOR(ES):{" "}
                  </Text>
                  <Text padding="2px 3px">{data.senores}</Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    NIT:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.nit}</Text>
                </Text>
              </View>
            </View>
            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Doc. Embarque:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.docEmbarque}</Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Int. Agencia:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.intAgencia}</Text>
                </Text>
              </View>
            </View>
            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Facturas(s):{" "}
                  </Text>
                  <Text padding="2px 3px">{data.facturas}</Text>
                </Text>
              </View>
              <View width="25%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Bultos:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.bultos}</Text>
                </Text>
              </View>
              <View width="25%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Peso:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.peso}</Text>
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              // style={{ marginTop: "5px" }}
              padding="0px 0px 3px 0px"
            >
              <View>
                <View width="50%">
                  <Text padding="2px 3px">
                    <Text padding="2px 3px" bold>
                      Proveedor/Emisor:{" "}
                    </Text>
                    <Text padding="2px 3px">{data.proveedor}</Text>
                  </Text>
                </View>
              </View>
              <Text padding="2px 3px">
                <Text padding="2px 3px" bold>
                  Mercadería:{" "}
                </Text>
                <Text padding="2px 3px">{data.mercancia}</Text>
              </Text>
            </View>
            <View border={{ top: true, bottom: true }} padding="3px 0px 3px 0px">
              <View width="13%" flexDirection="column">
                <Text padding="2px 3px" bold>
                  Valor FOB
                </Text>
                <Text padding="2px 3px" bold>
                  Fletes I,II
                </Text>
                <Text padding="2px 3px" bold>
                  Seguro
                </Text>
                <Text padding="2px 3px" bold>
                  Otros Gastos
                </Text>
                <Text padding="2px 3px" bold>
                  Gastos Puerto
                </Text>
                <Text padding="2px 3px" bold>
                  Otros Erogaciones
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
                <Text padding="2px 3px" bold>
                  T.c.
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
              </View>
              <View width="5%" flexDirection="column">
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">{data.tc}</Text>
                <Text padding="2px 3px">Bs.</Text>
              </View>
              <View
                width="12%"
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Text padding="2px 3px">{data.valorFob}</Text>
                <Text padding="2px 3px">{data.flete1y2}</Text>
                <Text padding="2px 3px">{data.seguro}</Text>
                <Text padding="2px 3px">{data.otrosGastos}</Text>
                <Text padding="2px 3px">{data.valorCif}</Text>
                <Text padding="2px 3px"> </Text>
                <Text padding="2px 3px">{data.valorCifBs}</Text>
              </View>
              <View
                style={{ marginLeft: "5%" }}
                width="50%"
                flexDirection="column"
              >
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Aduana:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.aduana}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Modalidad:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.modalidad}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Items:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.items}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Tipo:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.tipo}</Text>
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>A - Tributos y otros Conceptos Aduaneros</Text>
            </View>
            {data.aList.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between">
                    <View width="50%">
                      <Text>
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text textAlign="end">{element.description}</Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text bold>Sub Total:</Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text bold textAlign="end">
                  {data.aSubTotal}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>B - Otros Gastos de Importacion/Exportacion</Text>
            </View>
            {data.bList.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between">
                    <View width="50%">
                      <Text>
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text textAlign="end">{element.description}</Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text bold>Sub Total:</Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text bold textAlign="end">
                  {data.bSubTotal}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>C - Gastos de Operaciones</Text>
            </View>
            {data.cList.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between">
                    <View width="50%">
                      <Text>
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text textAlign="end">{element.description}</Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text bold>Sub Total:</Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text bold textAlign="end">
                  {data.cSubTotal}
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>D - Honorarios Profesionales</Text>
            </View>
            {data.dList.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between">
                    <View width="50%">
                      <Text>
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text textAlign="end">{element.description}</Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text bold>Sub Total:</Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text bold textAlign="end">
                  {data.dSubTotal}
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              padding="5px"
              border={{ top: true, bottom: true }}
              style={{ marginTop: "5px" }}
            >
              <View style={{ position: 'absolute' }} flexDirection="column" width="35%">
                <View>
                  <Text padding="0px 0px" bold>
                    Observaciones:
                  </Text>
                </View>
                <View>
                  <Text padding="3px 0px">
                    {data.clarifications}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="35%">
                  <Text bold>
                    Tributos Aduaneros, otros Gastos y Factura (Bs.)
                  </Text>
                </View>
                <View borderContent width="20%" justifyContent="flex-end">
                  <Text bold textAlign="end">
                    {data.tributosAduanerosOtrosGastosYFactura}
                  </Text>
                </View>
              </View>
              {data.descuentosBs &&
                data.descuentosBs !== "-" &&
                data.descuentosBs !== "0" ? (
                <View justifyContent="flex-end">
                  <View width="12.5%">
                    <Text bold>Descuento (Bs.)</Text>
                  </View>
                  <View
                    border={{ right: true, left: true, bottom: true }}
                    width="20%"
                    justifyContent="flex-end"
                  >
                    <Text bold textAlign="end">
                      {data.descuentosBs}
                    </Text>
                  </View>
                </View>
              ) : null}
              <View justifyContent="flex-end">
                <View width="15.5%" justifyContent="flex-end">
                  <Text bold>Total Proforma (Bs.)</Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text bold textAlign="end">
                    {data.totalProformaBs}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="19%" justifyContent="flex-end">
                  <Text bold>Total Proforma $us. 6.85</Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text bold textAlign="end">
                    {data.totalProformaSus}
                  </Text>
                </View>
              </View>
            </View>
            {data.clarifications ? (
              <Text color="#004080" fontSize="7px" bold>
                ACLARACIONES: {data.clarifications}
              </Text>
            ) : null}
            <View>
              <View width="50%" flexDirection="column">
                <Text color="#004080" bold>
                  BANCO UNION S.A. (Cta. Corriente)
                </Text>
                <Text>Cuenta En Bs.: {accountNumber && accountNumber !== "" ? accountNumber : data.accountNumber}</Text>
                <Text>ACIABOL S.R.L</Text>
              </View>
              <View width="50%" flexDirection="column">
                <Text>
                  Elaborado por: {user?.user?.name} {user?.user?.fatherLastName}{" "}
                  {user?.user?.motherLastName}
                </Text>
                <Text>NIT: 375482020</Text>
                <Text>SWIFT: BAUNBO22</Text>
              </View>
            </View>
            <Text fontSize="7px">
              Nota.: La presente Proforma esta sujeta a Cambio dentro del plazo
              requerido por Tradecruz SRL por variacion en el T./C.
            </Text>
          </View>
          <View
            flexDirection="column"
            padding="4px 0"
            justifyContent="center"
            alignItems="center"
            style={{ backgroundColor: "#002747" }}
          >
            <Text color="white">
              Av. 20 de Octubre Nro. 1507, Edificio Málaga, Piso 2 OF 11B - Sopocachi, La Paz
            </Text>
            <Text color="white">
              Teléfono: +591 77713481 Teléfono: (2) 2203462
            </Text>
          </View>
        </View>
      </Page>
      <Page size="A4" style={{ padding: "20px" }}>
        <View flexDirection="column" borderContent>
          <View padding="8px" style={{ backgroundColor: "#d38c19" }}></View>
          <View flexDirection="column">
            <View
              justifyContent="center"
              alignItems="center"
              padding="2px 0"
              width="100%"
            >
              <Text padding="10px 3px 2px" textAlign='center' bold fontSize='11px'>
                CONDICIONES GENERALES
              </Text>
            </View>
            <TextSubTitle
              text='BASE LEGAL'
            />
            {
              [
                "• Art. 42 del Capítulo III de la Ley General de Aduanas Nº 1990 define al Despachante de Aduana como la persona natural y profesional auxiliar de la función pública aduanera, autorizado por la Aduana Nacional para realizar gestiones inherentes a operaciones de comercio exterior por cuenta de terceros.",
                "• Art. 46 del Capítulo III de la Ley General de Aduanas Nº 1990 establece que el Despachante de Aduana y la Agencia Despachante de Aduana realizan su labor bajo el principio de buena fe y presunción de veracidad, por cuenta del comitente o consignatario de las mercancías.",
                "• Art. 48 de la Ley General de Aduanas Nº 1990 indica que el Despachante y la Agencia Despachante de Aduana, solo a efectos de la valoración aduanera, se regirán por lo dispuesto en el Acuerdo del GATT – 1994, y no asumirán responsabilidad sobre la veracidad y exactitud de la Declaración Jurada del Valor en Aduanas, la cual debe ser realizada por el importador.",
                "• Art. 51 del Capítulo III de la Ley General de Aduanas Nº 1990 señala que la Agencia Despachante de Aduana, mediante su representante legal (el Despachante de Aduana), podrá constituirse y apelar al cumplimiento de las normas vigentes bajo cualquiera de las formas jurídicas reconocidas por el Código de Comercio.",
                "• Art. 111 del Reglamento a la Ley General de Aduanas (D.S. 25870) estipula la documentación necesaria con carácter obligatorio para realizar la declaración de mercancías correspondiente, la cual será puesta a disposición y revisión de la Administración Aduanera de turno. Art. 20 del Reglamento a la Ley General de Aduanas (D.S. 25870) estipula el criterio por el cual se determina la base imponible sobre la cual se realizará el pago correspondiente de la tributación aduanera."
              ].map((data, index) => (
                <TextParagraph
                  key={index}
                  text={data}
                />))
            }
            <TextSubTitle
              text='BASE CONTRACTUAL'
            />
            {
              [
                "• El presente documento es emitido conforme solicitud del comitente o consignatario a partir de la presentación de documentación soporte suficiente para determinar lo estipulado según Art. 20 del Reglamento a la Ley General de Aduanas D.S. 25870.",
                "• La validez del presente documento tiene una duración de 7 días calendario a partir de la fecha de emisión, siempre y cuando los valores finales de la documentación soporte no sufran ningún cambio en relación a la cotización de monedas vigente emitida por el Banco Central de Bolivia y exigida por Aduana Nacional.",
                "• La presente proforma/cotización en ninguno de los casos ampara transporte de mercadería antes y después de las gestiones dentro del Recinto Aduanero de turno, siendo esta responsabilidad exclusiva del comitente, consignatario y/o agente de carga contratado directamente por el comitente o consignatario.",
                "• El presente documento queda sujeto a modificación sin previo aviso por parte de la Agencia Despachante de Aduana TRADECRUZ SRL, estableciendo que los valores que cite el mismo son temporales y/o aproximados.",
                "• Las proformas/cotizaciones están expresadas en dólares al tipo de cambio a la fecha de la emisión del documento; en caso que este cambiara, la deuda se actualizará en moneda extranjera dólares.",
                "• El pago de la siguiente cotización/proforma por transferencia, efectivo, depósito, cheque o cualquier otro medio genera la aceptación de la misma, sujetándose el comitente, consignatario o intermediario a las condiciones antes estipuladas sin derecho a reclamos posteriores.",
                "• El valor final del presente documento debe ser cancelado a las siguientes cuentas habilitadas:"
              ].map((data, index) => (
                <TextParagraph
                  key={index}
                  text={data}
                // color={index === 2 ? '#ff0000' : undefined}
                />))
            }
            <TextSubTitle
              text='CUENTAS TRADECRUZ SRL BANCO UNION S.A. MONEDA NACIONAL (Bolivianos)'
            />
            {
              [
                "a)	10000030319095",
                "b)	10000030108464",
                "c)	10000030318930",
                "d)	10000030319045",
              ].map((data, index) => (
                <TextParagraph
                  padding="2px 20px"
                  key={index}
                  text={data}
                />))
            }
            {
              [
                "- Enviar recibo escaneado a los correos una vez realizado el depósito."
              ].map((data, index) => (
                <TextParagraph
                  padding="24px 5px"
                  key={index}
                  text={data}
                />))
            }
          </View>
          <View padding="67px"></View>
        </View>
      </Page>
    </Document>
  );

  async function handleOnClick() {
    await pdf(MyDoc)
      .toBlob()
      .then((r) => {
        var file = new File([r], `Proforma-${dayjs().format("DD-MM-YYYY")}`);
        uploadFile(file);
      });
  }

  async function uploadFile(file) {
    let formData = new FormData();
    formData.append("Name", `Proforma-${dayjs().format("DD-MM-YYYY")}`);
    formData.append("File", file);
    formData.append(
      "originalName",
      `Proforma-${dayjs().format("DD-MM-YYYY")}.pdf`
    );
    formData.append("Status", "verified");
    formData.append("ProcedureId", procedure.id || procedure.procedureId);
    await requestAuth("post", "/files", formData)
      .then((res) => {
        handleRegister({
          url: res.data.url,
          name: `Proforma-${dayjs().format("DD-MM-YYYY")}`,
        });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function handleRegister(values) {
    await requestAuth(
      "post",
      `/fileState/procedure/${procedure.id || procedure.procedureId}/field/590`,
      values
    )
      .then(() => {
        toast.success("Se guardado el documento!");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

export default RenderLiquidaciónProforma;